import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { useQuery, useMutation, gql, useApolloClient } from "@apollo/client";
import orderBy from "lodash/orderBy";

import Header from "../components/Headers/Header";
import CustomLoader from "../components/Loader/CustomLoader";
import DataTable from "react-data-table-component";

import {
  getMinPurchaseOffers,
  DeleteMinPurchaseOffer,
  getproductsforcs,
} from "../apollo";

import { customStyles } from "../utils/tableForManagePurchaseOffer";
import useGlobalStyles from "../utils/globalStyles";
import TableHeader from "../components/TableHeader";
import AddPurchaseOffer from "../components/AddPurchaseOffer/AddPurchaseOffer";

import {
  Container,
  Button,
  Modal,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  Typography,
  Paper,
  Box,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Icon } from "@iconify/react";



const GET_MIN_PURCHASE_OFFERS = gql`
  ${getMinPurchaseOffers}
`;

const DELETE_MIN_PURCHASE_OFFER = gql`
  ${DeleteMinPurchaseOffer}
`;

const GET_PRODUCTS_FOR_CS = gql`
  ${getproductsforcs}
`;



const ActionMenu = ({ row, onEdit, onDelete, t, disableDelete = false }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
        <MoreVertIcon fontSize="small" />
      </IconButton>

      <Paper>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={() => setAnchorEl(null)}
        >

          <MenuItem
            onClick={() => {
              setAnchorEl(null);
              onEdit(row);
            }}
            style={{ height: 25 }}
          >
            <ListItemIcon>
              <EditIcon fontSize="small" style={{ color: "green" }} />
            </ListItemIcon>
            <Typography color="green">{t("Edit")}</Typography>
          </MenuItem>

          {/* Delete */}
          <MenuItem
            disabled={disableDelete}
            onClick={() => {
              if (disableDelete) return;
              setAnchorEl(null);
              onDelete(row);
            }}
            style={{ height: 25 }}
          >
            <ListItemIcon>
              <DeleteIcon fontSize="small" style={{ color: "red" }} />
            </ListItemIcon>
            <Typography color="red">{t("Delete")}</Typography>
          </MenuItem>
        </Menu>
      </Paper>
    </>
  );
};



const ManageMinPurchaseOffer = (props) => {
  const { t } = props;
  const client = useApolloClient();
  const globalClasses = useGlobalStyles();


  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(null);

  const [viewModal, setViewModal] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [viewProductsLoading, setViewProductsLoading] = useState(false);



  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [offerToDelete, setOfferToDelete] = useState(null);


  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");


  const { data, loading, refetch } = useQuery(GET_MIN_PURCHASE_OFFERS, {
    onError: (error) => {
      const forbidden =
        error &&
        error.graphQLErrors &&
        error.graphQLErrors.some(
          (e) => e.extensions && e.extensions.code === "FORBIDDEN"
        );

      if (forbidden) {
        localStorage.clear();
        client.clearStore();
        props.history.push("/auth/login");
      }
    },
  });



  const [deleteOffer] = useMutation(DELETE_MIN_PURCHASE_OFFER, {
    refetchQueries: [{ query: GET_MIN_PURCHASE_OFFERS }],

    onCompleted: () => {
      setAlertMessage("Offer Deleted Successfully");
      setAlertSeverity("success");
      setAlertOpen(true);
    },

    onError: () => {
      setAlertMessage("Something went wrong!");
      setAlertSeverity("error");
      setAlertOpen(true);
    },
  });



  const openEditModal = (offer) => {
    setSelectedOffer(offer);
    setEditModal(true);
  };

  const handleDeleteClick = (offer) => {
    setOfferToDelete(offer);
    setShowDeleteConfirmation(true);
  };

  const confirmDeleteOffer = () => {
    if (offerToDelete) {
      deleteOffer({
        variables: {
          removeMinPurchaseOfferId: offerToDelete._id,
        },
      });
    }

    setShowDeleteConfirmation(false);
    setOfferToDelete(null);
  };

  const getProductName = (product) =>
    product && (product.displayName || product.name || product.productName);

  const openProductsView = async (offer) => {
    const products = offer.specialPriceProducts || [];
    const offerStoreId =
      offer.storeId ||
      (JSON.parse(localStorage.getItem("user-native")) || {}).storeId ||
      "";

    const productIds = [...new Set(products.map((p) => p.productId).filter(Boolean))];
    if (productIds.length === 0) {
      setSelectedProducts(products.map((product) => ({
        ...product,
        productName: product.productName || product.productId,
      })));
      setViewModal(true);
      return;
    }

    setViewProductsLoading(true);
    setViewModal(true);

    try {
      const { data: productListData } = offerStoreId
        ? await client.query({
            query: GET_PRODUCTS_FOR_CS,
            variables: {
              storeId: offerStoreId,
              skip: 0,
              limit: 1000,
            },
            fetchPolicy: "cache-first",
          })
        : { data: null };

      const storeProducts =
        (productListData &&
          productListData.getProductsForCS &&
          productListData.getProductsForCS.products) ||
        [];

      const productNameMap = storeProducts.reduce((map, product) => {
        if (product && product._id) {
          map[product._id] = getProductName(product) || product._id;
        }
        return map;
      }, {});

      setSelectedProducts(
        products.map((product) => ({
          ...product,
          productName:
            productNameMap[product.productId] ||
            product.productName ||
            product.productId,
        }))
      );
    } catch (error) {
      setSelectedProducts(
        products.map((product) => ({
          ...product,
          productName: product.productName || product.productId,
        }))
      );
    } finally {
      setViewProductsLoading(false);
    }
  };

  var offers = (data && data.getMinPurchaseOffers) || [];

  const columns = [
    { name: "Sl No.", cell: (_, index) => index + 1 },

    { name: "Name", selector: (row) => row.name, sortable: true },
    { name: "Min Purchase", selector: (row) => row.minPurchaseAmount },

    {
      name: "Start Date",
      selector: (row) =>
        row.startDate ? new Date(row.startDate).toLocaleDateString() : "-",
    },

    {
      name: "End Date",
      selector: (row) =>
        row.endDate ? new Date(row.endDate).toLocaleDateString() : "-",
    },

    {
      name: "Status",
      cell: (row) => (
        <span style={{ color: row.isActive ? "green" : "red" }}>
          {row.isActive ? "Active" : "Inactive"}
        </span>
      ),
    },

    {
      name: "Offer Products",
      cell: (row) => (
        <Button
          variant="outlined"
          size="small"
          onClick={() => openProductsView(row)}
        >
          View
        </Button>
      ),
    },

    {
      name: "Action",
      cell: (row) => (
        <ActionMenu
          row={row}
          t={t}
          onEdit={openEditModal}
          onDelete={handleDeleteClick}           
          disableDelete={true}
        />
      ),
    },
  ];



  const customSort = (rows, field, direction) => {
    const value = (row) =>
      row[field] && row[field].toString().toLowerCase();
    return orderBy(rows, value, direction);
  };

  return (
    <>
      <Header />

      <Container className={globalClasses.flex} fluid>

        <Box textAlign="right" mb={3}>
          <Button
            className={globalClasses.dashbordBtn}
            onClick={() => setAddModal(true)}
          >
            <Icon icon="ic:twotone-plus" style={{ color: "white" }} />
            {t("Add New Min Purchase Offer")}
          </Button>
        </Box>


        {loading ? (
          <CustomLoader />
        ) : (
          <DataTable
            title={<TableHeader title={t("Manage Min Purchase Offers")} />}
            columns={columns}
            data={offers}
            pagination
            customStyles={customStyles}
            sortFunction={customSort}
          />
        )}

        <Modal open={addModal} onClose={() => setAddModal(false)}>
          <AddPurchaseOffer
            onClose={() => setAddModal(false)}
            refetch={refetch}
            vendor={null}
          />
        </Modal>

        <Modal open={editModal} onClose={() => setEditModal(false)}>
          <AddPurchaseOffer
            onClose={() => setEditModal(false)}
            refetch={refetch}
            vendor={selectedOffer}
          />
        </Modal>


        <Modal open={viewModal} onClose={() => setViewModal(false)}>
          <Box
            sx={{
              width: { xs: "92vw", sm: 760 },
              bgcolor: "white",
              borderRadius: 2,
              p: 3,
              maxHeight: "80vh",
              overflowY: "auto",
              margin: "auto",
              mt: "10%",
            }}
          >
            <Typography variant="h6" fontWeight="bold" mb={2} sx={{ color: "black" }}>
              Special Price Products
            </Typography>

            {viewProductsLoading ? (
              <CustomLoader />
            ) : selectedProducts.length > 0 ? (
              <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 1, overflow: "hidden" }}>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "2fr 1.4fr 1fr 1fr",
                    bgcolor: "#f5f7ff",
                    borderBottom: "1px solid #e0e0e0",
                  }}
                >
                  {["Product Name", "SKU ID", "Special Price", "Max Qty"].map((label) => (
                    <Typography
                      key={label}
                      sx={{
                        color: "black",
                        fontWeight: 700,
                        fontSize: 13,
                        p: 1.25,
                      }}
                    >
                      {label}
                    </Typography>
                  ))}
                </Box>

                {selectedProducts.map((p, i) => (
                <Box
                  key={i}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "2fr 1.4fr 1fr 1fr",
                    borderBottom:
                      i === selectedProducts.length - 1 ? "none" : "1px solid #e0e0e0",
                  }}
                >
                  <Typography sx={{ color: "black", p: 1.25, fontSize: 13 }}>
                    {p.productName || p.productId || "-"}
                  </Typography>
                  <Typography sx={{ color: "black", p: 1.25, fontSize: 13 }}>
                    {p.skuId || "-"}
                  </Typography>
                  <Typography sx={{ color: "black", p: 1.25, fontSize: 13 }}>
                    {p.specialPrice}
                  </Typography>
                  <Typography sx={{ color: "black", p: 1.25, fontSize: 13 }}>
                    {p.maxQty}
                  </Typography>
                </Box>
                ))}
              </Box>
            ) : (
              <Typography sx={{ color: "black" }}>No Products Found</Typography>
            )}

            <Box textAlign="right" mt={2}>
              <Button
                className={globalClasses.modalCancleBtn}
                onClick={() => setViewModal(false)}
              >
                Close
              </Button>
            </Box>
          </Box>
        </Modal>


        <Dialog
          open={showDeleteConfirmation}
          onClose={() => setShowDeleteConfirmation(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ backgroundColor: "#637BFE" }}>
            <Typography sx={{ color: "white", fontWeight: 500 }}>
              {t("Confirm Delete Offer")}
            </Typography>
          </DialogTitle>

          <DialogContent dividers>
            <Typography style={{ color: "black" }}>
              Are you sure you want to delete this offer?
            </Typography>

            {offerToDelete && (
              <Typography mt={2} fontWeight="bold" color="red">
                {offerToDelete.name}
              </Typography>
            )}
          </DialogContent>

          <DialogActions>
            <Button
              onClick={() => setShowDeleteConfirmation(false)}
              className={globalClasses.modalCancleBtn}
            >
              {t("No")}
            </Button>

            <Button
              onClick={confirmDeleteOffer}
              className={globalClasses.dashbordBtn}
              color="error"
            >
              {t("Yes, Delete")}
            </Button>
          </DialogActions>
        </Dialog>


        <Snackbar
          open={alertOpen}
          autoHideDuration={4000}
          onClose={() => setAlertOpen(false)}
        >
          <Alert severity={alertSeverity}>{alertMessage}</Alert>
        </Snackbar>
      </Container>
    </>
  );
};

export default withTranslation()(ManageMinPurchaseOffer);
